export default "__VITE_ASSET__2iJLghrh__"